const navLvlOneTriggers = document.querySelectorAll('.headermenunew-dropdown-menu');

navLvlOneTriggers.forEach(trigger => {
    trigger.addEventListener('click', function () {
        trigger.classList.toggle('open');
    });
});

const navLvlTwoTriggers = document.querySelectorAll('.headermenunew-dropdown-content');

navLvlTwoTriggers.forEach(trigger => {
    trigger.addEventListener('click', function (event) {
        event.stopPropagation(); // verhindert, dass Level 1 reagiert
        trigger.classList.toggle('open');
    });
});